export const CURRENCIES = [
    {"id": "USD", "name": "USD $"},
    {"id": "EUR", "name": "EUR €"},
    {"id": "JPY", "name": "JPY ¥"},
    {"id": "GBP", "name": "GBP £"},
    {"id": "AUD", "name": "AUD A$"},
    {"id": "CAD", "name": "CAD CA$"},
    {"id": "CHF", "name": "CHF CHF"},
    {"id": "CNY", "name": "CNY ¥"},
    {"id": "SEK", "name": "SEK kr"},
    {"id": "NZD", "name": "NZD NZ$"},
    {"id": "MXN", "name": "MXN $"},
    {"id": "SGD", "name": "SGD S$"},
    {"id": "HKD", "name": "HKD HK$"},
    {"id": "NOK", "name": "NOK kr"},
    {"id": "KRW", "name": "KRW ₩"},
    {"id": "TRY", "name": "TRY ₺"},
    {"id": "INR", "name": "INR ₹"},
    {"id": "RUB", "name": "RUB ₽"},
    {"id": "BRL", "name": "BRL R$"},
    {"id": "ZAR", "name": "ZAR R"},
    {"id": "PLN", "name": "PLN zł"},
    {"id": "MYR", "name": "MYR RM"},
    {"id": "THB", "name": "THB ฿"},
    {"id": "IDR", "name": "IDR Rp"},
    {"id": "PHP", "name": "PHP ₱"},
    {"id": "ILS", "name": "ILS ₪"},
    {"id": "AED", "name": "AED د.إ"},
    {"id": "COP", "name": "COP $"},
    {"id": "CLP", "name": "CLP $"},
    {"id": "KRW", "name": "KRW ₩"},
    {"id": "EGP", "name": "EGP ج.م"},
    {"id": "SAR", "name": "SAR ر.س"},
    {"id": "VND", "name": "VND ₫"},
    {"id": "NGN", "name": "NGN ₦"},
    {"id": "BHD", "name": "BHD .د.ب"},
    {"id": "QAR", "name": "QAR ر.ق"},
    {"id": "KWD", "name": "KWD د.ك"},
    {"id": "OMR", "name": "OMR ر.ع."},
    {"id": "JOD", "name": "JOD د.ا"},
    {"id": "TWD", "name": "TWD NT$"},
    {"id": "DKK", "name": "DKK kr"},
    {"id": "HUF", "name": "HUF Ft"},
    {"id": "ISK", "name": "ISK kr"},
    {"id": "RSD", "name": "RSD дин."},
    {"id": "HRK", "name": "HRK kn"},
    {"id": "CZK", "name": "CZK Kč"},
    {"id": "LKR", "name": "LKR Rs"},
    {"id": "BWP", "name": "BWP P"},
    {"id": "BGN", "name": "BGN лв."},
    {"id": "KZT", "name": "KZT тңг."},
    {"id": "UZS", "name": "UZS сум"},
    {"id": "AMD", "name": "AMD դր."},
    {"id": "AZN", "name": "AZN ₼"},
    {"id": "GEL", "name": "GEL ლ"},
    {"id": "BYN", "name": "BYN Br"},
    {"id": "MZN", "name": "MZN MT"},
    {"id": "KPW", "name": "KPW ₩"},
    {"id": "TJS", "name": "TJS SM"},
    {"id": "SYP", "name": "SYP ل.س"},
    {"id": "NPR", "name": "NPR रू"},
    {"id": "LTL", "name": "LTL Lt"},
    {"id": "LVL", "name": "LVL Ls"},
    {"id": "MKD", "name": "MKD ден."},
    {"id": "MNT", "name": "MNT ₮"},
    {"id": "MDL", "name": "MDL Lei"},
    {"id": "PEN", "name": "PEN S/."},
    {"id": "SLL", "name": "SLL Le"},
    {"id": "XOF", "name": "XOF CFA"},
    {"id": "XPF", "name": "XPF ₣"}
  ]